/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableCell, TableRow } from "@material-ui/core"
import { ModalDeleteConfirm, TableAction } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables } from "App/hooks"
import {
  defaultToastError,
  formatNumber,
  isNull,
  defaultToastSuccess,
  convertToValidPrice,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import React, { useContext, useEffect, useState } from "react"
import {
  DaftarPaket,
  getTotal,
  getTotalFilterID,
  Perhitungan,
  usePembulatanPenjualan,
} from ".."
import { FormContext } from "../../context/FormContext"
import {
  ModalDaftarPaket,
  RESET_STATE_DAFTAR_PAKET,
  getPaketByPenjualanID,
  deletePaketById,
} from "./DaftarPaket/helpers"

function TabPaket({
  perhitunganPenjualan,
  setPerhitunganPenjualan,

  rowsPaketByKelas,
  setNewDataPaketByKelas,
  loading,

  handleClickReset,

  totalDataPaketByKelas,

  formFilterPaketByKelas,
  setFormFilterPaketByKelas,
}) {
  const [rows, setRows] = useState([])

  const [formPaket, setFormPaket] = useState(RESET_STATE_DAFTAR_PAKET)
  const { formData, setFormData } = useContext(FormContext)
  const pembulatan = usePembulatanPenjualan()

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [showModalPaket, setShowModalPaket] = useState(false)

  const getPaketDijual = () => {
    if (isNull(formData.penjualan_id)) {
      const paket = formData.paket.filter(
        (e) =>
          e.kelas_id === formData.kelas_id &&
          e.asuransi_id === formData.asuransi_id,
      )
      setRows(paket)
    }
  }

  const deletePaketDijual = async () => {
    const filterPaket = rows.filter((e) => e.id !== formPaket.id)

    if (!isNull(formData.penjualan_id)) {
      const totalPaket = await getTotalFilterID(rows, formPaket.id, "paket")

      const totalBarang = getTotal(formData.barang, "barang")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")

      const jumlah =
        totalBarang + totalRikjang + totalPaket + totalJasa + totalFasilitas

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const form = {
        id: formPaket.id,
        penjualanId: formData.penjualan_id,
        harga_total_paket: convertToValidPrice(totalPaket),
        total_penjualan: convertToValidPrice(jumlah),
        sisa: convertToValidPrice(total),

        tax: taxPercent,
        jumlah_tax: convertToValidPrice(taxNumber),
        discount: convertToValidPrice(formData.potongan / total),
        jumlah_set_discount: potongan,
      }
      const res = await deletePaketById(form)
      if (res.state) {
        setShowModalDeleteConfirm(false)
        await setNewPaketDijual(filterPaket, false)
        defaultToastSuccess(res.message)
      } else {
        setShowModalDeleteConfirm(false)
        defaultToastError(res.message)
      }
    } else {
      setShowModalDeleteConfirm(false)
      await setNewPaketDijual(filterPaket, false)
      defaultToastSuccess("List paket berhasil dihapus")
    }
  }

  function clickUpdate(row) {
    setShowModalPaket(!showModalPaket)

    if (isNull(formData.penjualan_id)) {
      setFormPaket({
        id: row.id,
        mh_paket_id: row?.mhPaketId,
        paket_id: row?.paket_id,
        qty: row?.qty,
        keterangan: row.qty,
        harga: row.harga,
        hargaCustom: row.hargaCustom,
        hargaCustom2: row.hargaCustom2,
        kelas_id: row.kelas_id,
        asuransi_id: row.asuransi_id,
        namaPaket: row.namaPaket,

        doctor_id: isNull(row.docter_id) ? null : parseInt(row.doctor_id),
        doctor_name: isNull(row.doctor_name) ? "Pilih Dokter" : row.doctor_name,
      })
    } else {
      setFormPaket({
        id: row.id,
        mh_paket_id: row?.mhPaketId,
        paket_id: row?.paket_id,
        qty: row?.qty,
        keterangan: row.qty,
        harga: row.harga,
        hargaCustom: row.hargaCustom,
        hargaCustom2: formatNumber(row.hargaCustom),
        namaPaket: row.namaPaket,

        total: row.hargaCustom * parseInt(row.qty),

        gudang_id: formData.gudang_id,
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,

        doctor_id: isNull(row.docter_id) ? null : parseInt(row.doctor_id),
        doctor_name: isNull(row.doctor_name) ? "Pilih Dokter" : row.doctor_name,
      })
    }
    setShowModalPaket(!showModalPaket)
  }

  function clickDelete(row) {
    setFormPaket({
      ...formPaket,
      id: row?.id,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  useEffect(() => {
    ;(async () => {
      await setNewDataPaketByKelas()
      if (isNull(formData.penjualan_id)) {
        getPaketDijual()
      }
    })()
  }, [formData.kelas_id, formData.asuransi_id])

  const handleClickSelect = (row) => {
    if (!isNull(formData.kelas_id)) {
      setFormPaket({
        id: "",
        paket_id: row.id_paket,
        mh_paket_id: row.id,
        qty: 1,
        keterangan: "-",
        harga: row.harga,
        hargaCustom: row.harga_custom,
        hargaCustom2: formatNumber(row.harga_custom),
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,

        namaPaket: row.namaPaket,

        doctor_id: null,
        doctor_name: "Pilih Dokter",
      })
      setShowModalPaket(!showModalPaket)
    } else {
      defaultToastError("Kelas tidak boleh kosong!")
    }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: isNull(rows) ? [] : rows,
    orderByDefault: "namaPaket",
    orderByRow: ["namaPaket"],
  })

  const setNewPaketDijual = async (
    paket = formData.paket,
    is_jurnal = formData.is_jurnal,
  ) => {
    if (isNull(formData.penjualan_id)) {
      setRows(paket)
      setFormData({
        ...formData,
        paket,
        is_jurnal,
      })
    } else {
      const res = await getPaketByPenjualanID(formData.penjualan_id)
      if (res.state) {
        setRows(res.data)
        setFormData({
          ...formData,
          paket: res.data,
          is_jurnal,
        })
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isNull(formData.penjualan_id)) {
        await setNewPaketDijual()
      }
    })()
  }, [
    formData.gudang_id,
    formData.kelas_id,
    formData.asuransi_id,
    formData.reload,
    formData.penjualan_id,
  ])

  let total = 0
  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deletePaketDijual()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalPaket && (
        <ModalDaftarPaket
          setShowModal={() => setShowModalPaket(false)}
          formPaket={formPaket}
          setFormPaket={setFormPaket}
          setNewPaketDijual={setNewPaketDijual}
          handleClickSelect={handleClickSelect}
          totalPenjualan={perhitunganPenjualan.jumlah}
          sisaPenjualan={perhitunganPenjualan.total}
          setNewDataPaketByKelas={setNewDataPaketByKelas}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6}>
          <DaftarPaket
            formPaket={formPaket}
            setFormPaket={setFormPaket}
            rows={rowsPaketByKelas}
            handleClickSelect={handleClickSelect}
            setNewDataPaketByKelas={setNewDataPaketByKelas}
            setNewPaketDijual={setNewPaketDijual}
            totalData={totalDataPaketByKelas}
            formFilterPaketByKelas={formFilterPaketByKelas}
            setFormFilterPaketByKelas={setFormFilterPaketByKelas}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Perhitungan
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
          />
        </Grid>
      </Grid>

      <div className="mt-1">
        <FreezeTableClient
          title="DAFTAR PAKET YANG DIJUAL"
          setQ={setQ}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              const jumlahRaw = row.hargaCustom * row.qty
              const jumlah = pembulatan(jumlahRaw)
              total += jumlah
              return (
                <TableRow hover key={index}>
                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {/* {!formData.is_lock && !formData.is_close && (
                      <TableAction
                        isUpdate={false}
                        clickDelete={() => clickDelete(row)}
                        clickUpdate={() => clickUpdate(row)}
                      />
                    )} */}
                  </TableCell>
                  <TableCell align="left">{row?.namaPaket}</TableCell>
                  <TableCell align="left">{row?.doctor_name}</TableCell>
                  <TableCell align="left" width={"5%"}>
                    {row?.qty}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.hargaCustom)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(pembulatan(jumlah))}
                  </TableCell>
                </TableRow>
              )
            })}
          {rows.length > 0 && (
            <TableRow>
              <TableCell colSpan={headCells.length - 1} align="right">
                TOTAL
              </TableCell>
              <TableCell align="right">
                {formatNumber(pembulatan(total))}
              </TableCell>
            </TableRow>
          )}
        </FreezeTableClient>
      </div>
    </>
  )
}

const MemoizeTabPaket = React.memo(TabPaket)
export default MemoizeTabPaket

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "doctor_name",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "BANYAK",
    align: "left",
  },
  {
    id: "hargaCustom2",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
]
